function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 1,
  width: 63,
  height: 63,
  rx: 31.5,
  stroke: "#DC3009"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.53 40.97a.75.75 0 11-1.06 1.06L32 33.561l-8.47 8.47a.75.75 0 01-1.06-1.06l8.469-8.47-8.47-8.47a.75.75 0 011.06-1.06L32 31.438l8.47-8.469a.75.75 0 011.06 1.06l-8.468 8.47 8.469 8.47z",
  fill: "#DC3009"
});

function SvgErrorCircleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgErrorCircleRed;